import { render, staticRenderFns } from "./sponsor-management.vue?vue&type=template&id=4031c721&scoped=true"
import script from "./sponsor-management.vue?vue&type=script&lang=js"
export * from "./sponsor-management.vue?vue&type=script&lang=js"
import style0 from "./sponsor-management.vue?vue&type=style&index=0&id=4031c721&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4031c721",
  null
  
)

export default component.exports